<div class="mainDiv">
    <nav class="navbar first-nav">
        <div id="homepage">
        </div>
        <div class="input-group search">
            <input type="text" class="form-control controls" placeholder="Search by Location" (focus)="checkPrime()"
                aria-label="Search by Country" [disabled]="checkprime && !isPrime" id="pac-input"
                aria-describedby="basic-addon2" [(ngModel)]="Placesng">
            <!-- <div class="input-group-append"> -->
            <button class="btn" type="button">
                <img class="searchicon" *ngIf="showSearchIcon" src="{{constants.MAP_SEARCH_TEXTFIELD_ICON}}" />
                <button class="closeicon" (click)="Close()" *ngIf="!showSearchIcon">Clear</button>
            </button>
            <!-- </div> -->
        </div>
        <div (click)="OnClickClose()" id="closebutton">
            <img class="mapclose" src="{{constants.LOGIN_CLOSE_BUTTON}}" />
        </div>
    </nav>
    <div *ngIf="isPrime" id="maps"></div>
    <div (click)="checkPrime()" class="img-container" *ngIf="!isPrime">
        <img src="{{constants.MAP_PREVIEW_NON_PRIME}}" alt="">
    </div>
    <button (click)='onCLickOpenNewWindow()' class="open_window_button" *ngIf="mapsearchcontainer">
        {{ placeName === '' ? constants.OPEN_WINDOW_TXT : placeName | titlecase}}
    </button>
    <div *ngIf="isEmptyResult" class="empty-result-card">
        <div (click)="OnClickEmptyClose()" class="closebutton">
            <img class="mapclose" src="{{constants.LOGIN_CLOSE_BUTTON}}" />
        </div>
        <p class="empty-error">{{constants.NO_WINDOW}}</p>
        <p class="empty-error-sub">{{constants.IF_YOU_TXT}}<br>
            {{constants.PLEASE_ASK_TXT}}</p>
    </div>
    <div *ngIf="isNoResult" class="empty-result-card">
        <div (click)="OnClickEmptyClose()" class="closebutton">
            <img class="mapclose" src="{{constants.LOGIN_CLOSE_BUTTON}}" />
        </div>
        <p class="empty-error">{{constants.OOPS_NO_WINDOW_TXT}}</p>
    </div>
    <div *ngIf="checkprime" class="map-not-prime">
        <div (click)="OnClickEmptyClose()" class="closebutton">
            <img class="mapclose" src="{{constants.LOGIN_CLOSE_BUTTON}}" />
        </div>
        <div class="row">
            <div class="col imgcontainer">
                <img class="nonPrimeMap" src="{{constants.NOT_PRIME_MAP}}" />
            </div>
            <div class="col non-prime-mobile-content">
                <p class="nonPrimeMapText">{{constants.CHOOSE_FROM}}</p>
                <img class="nonPrimeMapmpbileView" src="{{constants.NOT_PRIME_MAP}}" />
                <p class="nonPrimeMapSubText">{{constants.GET_ALL_ACCESS}}</p>
                <p class="nonPrimeMapSubTextSub">{{constants.GET_ALL_ACCESS_SUB}}</p>
                <button (click)="toPaymentPage()"
                    class="btn btn-monthly-subscription">{{constants.MONTHLY_SUBSCRIPTION_NEW}}</button>
            </div>
        </div>
    </div>
</div>